// Layout of the Politique de Confidentialité page.
// Every text value is a translation key; the strings live in static/locales/<lang>/translation.json.

const legalPrivacy = {
	"title": "legal_privacy_title",
	"subtitle": "legal_privacy_subtitle",
	"sections": [
		{
			"id": "preambule",
			"title": "legal_privacy_preambule_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_preambule_p1"
				},
				{
					"type": "p",
					"text": "legal_privacy_preambule_p2"
				},
				{
					"type": "p",
					"text": "legal_privacy_preambule_p3"
				}
			]
		},
		{
			"id": "responsable",
			"number": "1",
			"title": "legal_privacy_responsable_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_responsable_p1"
				}
			]
		},
		{
			"id": "donnees-collectees",
			"number": "2",
			"title": "legal_privacy_donnees_collectees_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_donnees_collectees_p1"
				},
				{
					"type": "list",
					"style": "bullet",
					"items": [
						"legal_privacy_donnees_collectees_list2_a",
						"legal_privacy_donnees_collectees_list2_b",
						"legal_privacy_donnees_collectees_list2_c",
						"legal_privacy_donnees_collectees_list2_d",
						"legal_privacy_donnees_collectees_list2_e"
					]
				},
				{
					"type": "note",
					"text": "legal_privacy_donnees_collectees_note3"
				}
			]
		},
		{
			"id": "finalites",
			"number": "3",
			"title": "legal_privacy_finalites_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_finalites_p1"
				},
				{
					"type": "list",
					"style": "bullet",
					"items": [
						"legal_privacy_finalites_list2_a",
						"legal_privacy_finalites_list2_b",
						"legal_privacy_finalites_list2_c",
						"legal_privacy_finalites_list2_d",
						"legal_privacy_finalites_list2_e",
						"legal_privacy_finalites_list2_f",
						"legal_privacy_finalites_list2_g"
					]
				},
				{
					"type": "p",
					"text": "legal_privacy_finalites_p3"
				}
			]
		},
		{
			"id": "bases-legales",
			"number": "4",
			"title": "legal_privacy_bases_legales_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_bases_legales_p1"
				},
				{
					"type": "list",
					"style": "bullet",
					"items": [
						{
							"label": "legal_privacy_bases_legales_list2_a_label",
							"text": "legal_privacy_bases_legales_list2_a_text"
						},
						{
							"label": "legal_privacy_bases_legales_list2_b_label",
							"text": "legal_privacy_bases_legales_list2_b_text"
						},
						{
							"label": "legal_privacy_bases_legales_list2_c_label",
							"text": "legal_privacy_bases_legales_list2_c_text"
						},
						{
							"label": "legal_privacy_bases_legales_list2_d_label",
							"text": "legal_privacy_bases_legales_list2_d_text"
						},
						{
							"label": "legal_privacy_bases_legales_list2_e_label",
							"text": "legal_privacy_bases_legales_list2_e_text"
						}
					]
				},
				{
					"type": "p",
					"text": "legal_privacy_bases_legales_p3"
				}
			]
		},
		{
			"id": "destinataires",
			"number": "5",
			"title": "legal_privacy_destinataires_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_destinataires_p1"
				},
				{
					"type": "list",
					"style": "bullet",
					"items": [
						{
							"label": "legal_privacy_destinataires_list2_a_label",
							"text": "legal_privacy_destinataires_list2_a_text"
						},
						{
							"label": "legal_privacy_destinataires_list2_b_label",
							"text": "legal_privacy_destinataires_list2_b_text"
						},
						{
							"label": "legal_privacy_destinataires_list2_c_label",
							"text": "legal_privacy_destinataires_list2_c_text"
						},
						{
							"label": "legal_privacy_destinataires_list2_d_label",
							"text": "legal_privacy_destinataires_list2_d_text"
						},
						{
							"label": "legal_privacy_destinataires_list2_e_label",
							"text": "legal_privacy_destinataires_list2_e_text"
						}
					]
				}
			]
		},
		{
			"id": "transferts",
			"number": "6",
			"title": "legal_privacy_transferts_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_transferts_p1"
				}
			]
		},
		{
			"id": "conservation",
			"number": "7",
			"title": "legal_privacy_conservation_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_conservation_p1"
				},
				{
					"type": "table",
					"head": [
						"legal_privacy_conservation_table_head1",
						"legal_privacy_conservation_table_head2"
					],
					"rows": [
						[
							"legal_privacy_conservation_table_r1_c1",
							"legal_privacy_conservation_table_r1_c2"
						],
						[
							"legal_privacy_conservation_table_r2_c1",
							"legal_privacy_conservation_table_r2_c2"
						],
						[
							"legal_privacy_conservation_table_r3_c1",
							"legal_privacy_conservation_table_r3_c2"
						],
						[
							"legal_privacy_conservation_table_r4_c1",
							"legal_privacy_conservation_table_r4_c2"
						],
						[
							"legal_privacy_conservation_table_r5_c1",
							"legal_privacy_conservation_table_r5_c2"
						]
					]
				},
				{
					"type": "p",
					"text": "legal_privacy_conservation_p3"
				}
			]
		},
		{
			"id": "securite",
			"number": "8",
			"title": "legal_privacy_securite_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_securite_p1"
				},
				{
					"type": "p",
					"text": "legal_privacy_securite_p2"
				}
			]
		},
		{
			"id": "droits",
			"number": "9",
			"title": "legal_privacy_droits_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_droits_p1"
				},
				{
					"type": "p",
					"text": "legal_privacy_droits_p2"
				}
			]
		},
		{
			"id": "mineurs",
			"number": "10",
			"title": "legal_privacy_mineurs_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_mineurs_p1"
				}
			]
		},
		{
			"id": "dpo",
			"number": "11",
			"title": "legal_privacy_dpo_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_dpo_p1"
				}
			]
		},
		{
			"id": "mises-a-jour",
			"number": "12",
			"title": "legal_privacy_mises_a_jour_title",
			"blocks": [
				{
					"type": "p",
					"text": "legal_privacy_mises_a_jour_p1"
				}
			]
		},
		{
			"id": "resume",
			"highlight": true,
			"title": "legal_privacy_resume_title",
			"blocks": [
				{
					"type": "list",
					"style": "bullet",
					"items": [
						{
							"label": "legal_privacy_resume_list1_a_label",
							"text": "legal_privacy_resume_list1_a_text"
						},
						{
							"label": "legal_privacy_resume_list1_b_label",
							"text": "legal_privacy_resume_list1_b_text"
						},
						{
							"label": "legal_privacy_resume_list1_c_label",
							"text": "legal_privacy_resume_list1_c_text"
						},
						{
							"label": "legal_privacy_resume_list1_d_label",
							"text": "legal_privacy_resume_list1_d_text"
						},
						{
							"label": "legal_privacy_resume_list1_e_label",
							"text": "legal_privacy_resume_list1_e_text"
						},
						{
							"label": "legal_privacy_resume_list1_f_label",
							"text": "legal_privacy_resume_list1_f_text"
						},
						{
							"label": "legal_privacy_resume_list1_g_label",
							"text": "legal_privacy_resume_list1_g_text"
						}
					]
				},
				{
					"type": "note",
					"text": "legal_privacy_resume_note2"
				}
			]
		}
	]
};

export default legalPrivacy;
